module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination.pages !== null) ? _c('nav', {
    staticClass: "c-pagination t-pagination"
  }, [_c('button', {
    staticClass: "c-pagination__button c-pagination__button--previous t-pagination__button",
    attrs: {
      "disabled": _vm.pagination.previous === null
    },
    on: {
      "click": function($event) {
        return _vm.pagingCallback(_vm.pagination.previous)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-pagination__numbers"
  }, _vm._l((_vm.pagination.pages), function(page) {
    return (page != '...') ? _c('a', {
      staticClass: "c-pagination__numbers__number t-pagination__number",
      class: {
        'is-active': page === _vm.pagination.current
      },
      on: {
        "click": function($event) {
          return _vm.pagingCallback(page)
        }
      }
    }, [_c('span', {
      staticClass: "c-pagination__numbers__number__box t-pagination__number__box"
    }, [_vm._v(_vm._s(page))])]) : _c('span', {
      staticClass: "c-pagination__numbers__filler"
    }, [_vm._v(_vm._s(page))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "c-pagination__button c-pagination__button--next t-pagination__button",
    attrs: {
      "disabled": _vm.pagination.next === null
    },
    on: {
      "click": function($event) {
        return _vm.pagingCallback(_vm.pagination.next)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c87f958"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/shared/Paginate.vue
// module id = 509
// module chunks = 1